import * as React from "react";
import ReadService from "../../../service/read";
import Wait from "../../wait";
import ProjectScreen from "./project_screen";
import {ProjectsService} from "../../../service/v1/projects";
import ProjectInfoPane from "./project_info";

export default class ProjectContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            task: [
                {
                    "id": 8,
                    "name": "Project Inception",
                    "code": "project_inception",
                    "screens": [
                        {
                            "id": 21,
                            "name": "Project Info",
                            "code": "project_info"
                        }
                        ]
                }
            ],
            current_pane: <div>Loading...</div>,
            expandedTask: null // Track which task is expanded
        };
        this.fetchTaskList = this.fetchTaskList.bind(this);
        this.showScreenAt = this.showScreenAt.bind(this);
        this.handleExpandTask = this.handleExpandTask.bind(this);
    }
    componentDidMount() {
        if (this.props.project.action !== null && this.props.project.action.toLowerCase() === 'approved') {
            this.fetchTaskList();
        } else {
            this.setState({
                current_pane: <ProjectInfoPane key={new Date().getMilliseconds()} project={this.props.project} />
            });
        }
    }

    render() {
        // Styles
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const container = {
            display: 'flex',
            flexDirection: 'row',
            gap: 0,
            minHeight: '80vh',
            background: '#f6f8fa',
            fontFamily,
            borderRadius: 0,
            boxShadow: '0 4px 24px 0 rgba(57,93,154,0.10)',
            margin: 0,
            maxWidth: '100vw',
            width: '100vw',
            overflow: 'hidden',
        };
        const sidebar = {
            background: '#f7f9fa',
            color: '#000',
            minWidth: 180,
            maxWidth: 240,
            width: 220,
            padding: '24px 0 24px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            borderRight: '1px solid #e0e7ef',
            position: 'relative',
            zIndex: 2,
            fontSize: '13px',
            fontFamily,
            boxShadow: '0 4px 24px 0 rgba(57,93,154,0.10)',
        };
        const sidebarTitle = {
            fontWeight: 700,
            fontSize: 14,
            margin: '0 0 18px 32px',
            letterSpacing: 0.5,
            color: '#000',
            fontFamily,
        };
        const navSection = {
            marginBottom: 18,
            maxHeight: 'calc(100vh - 120px)',
            overflowY: 'auto',
        };
        const navItem = {
            padding: '8px 40px',
            fontSize: 13,
            fontWeight: 'normal',
            border: 'none',
            background: 'none',
            color: '#000',
            textAlign: 'left',
            cursor: 'pointer',
            borderRadius: 4,
            marginBottom: 2,
            transition: 'background 0.15s, color 0.15s, border-left 0.15s, padding 0.2s',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            borderLeft: '4px solid transparent',
            fontFamily,
            width: '100%',
            boxSizing: 'border-box',
        };
        const navItemActive = {
            ...navItem,
            background: '#e6eefc',
            color: '#000',
            fontWeight: 'bold',
            borderLeft: '4px solid #395d9a',
        };
        const navIcon = {
            marginRight: 10,
            fontSize: 15,
            marginLeft: 0,
            minWidth: 24,
            textAlign: 'center',
        };
        const main = {
            flex: 1,
            background: '#fff',
            padding: '24px 16px',
            minHeight: '80vh',
            borderRadius: '0 12px 12px 0',
            boxShadow: 'none',
            overflow: 'auto',
            fontSize: '15px',
        };
        // Add hover/active style for task headers
        const taskHeaderBase = {
            fontWeight: 700,
            fontSize: 14,
            color: '#000',
            margin: '0 0 6px 32px',
            letterSpacing: 0.2,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 4,
            transition: 'background 0.15s, color 0.15s, min-height 0.2s, margin 0.2s',
            minHeight: 36,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
        const taskHeaderActive = {
            ...taskHeaderBase,
            background: '#395d9a',
            color: '#fff',
            minHeight: 40,
        };
        // Responsive styles
        const responsive = `
        @media (max-width: 900px) {
            .project-container-flex { flex-direction: column; }
            .project-sidebar { min-width: 100%; max-width: 100%; width: 100%; border-right: none; border-bottom: 1px solid #e0e7ef; border-radius: 12px 12px 0 0; }
            .project-main { border-radius: 0 0 12px 12px; }
        }
        @media (max-width: 600px) {
            .project-sidebar { padding: 18px 0 18px 0; }
            .project-main { padding: 18px 6px; }
        }
        `;
        const transitionStyle = {
            transition: 'max-height 0.3s cubic-bezier(0.4,0,0.2,1)',
            overflow: 'hidden',
        };
        return (
            <div style={{width: '100%'}}>
                <style>{responsive}</style>
                <div className="project-container-flex" style={container}>
                    <aside className="project-sidebar" style={sidebar}>
                        <div style={sidebarTitle}><span className={'fa fa-folder-open'} style={{marginRight: 10}}/>Project Navigation</div>
                        <div style={navSection}>
                            {this.state.task.map((d, i) => (
                                <div key={i} style={{marginBottom: 12}}>
                                    <div
                                         style={this.state.expandedTask === i ? taskHeaderActive : taskHeaderBase}
                                         tabIndex={0}
                                         onClick={() => this.handleExpandTask(i)}
                                         onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && this.handleExpandTask(i)}
                                         onMouseOver={e => { if (this.state.expandedTask !== i) { e.currentTarget.style.background = '#395d9a'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.minHeight = '40px'; }}}
                                         onMouseOut={e => { if (this.state.expandedTask !== i) { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#000'; e.currentTarget.style.minHeight = '36px'; }}}
                                         aria-expanded={this.state.expandedTask === i}
                                    >
                                        <span className={'fa ' + (this.state.expandedTask === i ? 'fa-chevron-down' : 'fa-chevron-right')} style={navIcon}/>
                                        <span>{d.name}</span>
                                        {d.screens.length > 0 && d.screens.every(s => s.status) && (
                                            <span className="fa fa-check-circle" style={{ color: '#27ae60', marginLeft: 8, fontSize: 15, verticalAlign: 'middle', display: 'inline-block', width: 15, height: 15 }} title="All screens complete" />
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            ...transitionStyle,
                                            maxHeight: this.state.expandedTask === i ? 500 : 0,
                                            background: 'none',
                                            marginLeft: 0,
                                        }}
                                    >
                                        {d.screens.map((s, j) => (
                                            <button
                                                key={i + '_' + j}
                                                className="project-nav-item"
                                                style={this.state.current_pane && this.state.current_pane.key && this.state.current_pane.key === s.code ? navItemActive : navItem}
                                                onClick={() => this.showScreenAt(d, s, i, j)}
                                                onFocus={e => e.currentTarget.style.background = '#e6eefc'}
                                                onBlur={e => e.currentTarget.style.background = 'none'}
                                                onMouseOver={e => e.currentTarget.style.background = '#e6eefc'}
                                                onMouseOut={e => e.currentTarget.style.background = 'none'}
                                            >
                                                <span className={s.status ? 'fa fa-check' : 'fa fa-times'} style={navIcon}/>{s.name}
                                            </button>
                                        ))}
                                    </div>
                        </div>
                            ))}
                        </div>
                    </aside>
                    <main className="project-main" style={main}>
                        {this.state.current_pane}
                    </main>
            </div>
            </div>
        );
    }

    fetchTaskList() {
        try {
            Wait.show('Fetching Task....');
            ProjectsService.fetchTaskList(this.props.project.project_type_info.id, this.props.project.id).then(r => {
                Wait.dismiss();
                try {
                    this.setState({
                        task: r.data.results,
                        current_pane: ProjectScreen.getScreenByCode('project_info', this.props.project)
                    });
                } catch (e) {
                    console.log(e);
                }
            });
        } catch (e) {
            // handle error
        }
    }

    showScreenAt(task, screen, i, j) {
        this.setState({
            current_pane: ProjectScreen.getScreenByCode(screen.code, this.props.project, task.id, task.code)
        });
        // Optionally, highlight the active nav item (handled by style/hover/focus now)
    }

    handleExpandTask(idx) {
        this.setState(prev => ({
            expandedTask: prev.expandedTask === idx ? null : idx
        }));
    }
}
